export default __webpack_public_path__ + "static/media/bar_02.26e8a618.svg";